import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import AutocompleteAddressEntry from './autocomplete-address-entry';

export class AutocompleteAddress extends PureComponent {
  static propTypes = {
    type: PropTypes.string
  };

  static defaultProps = {
    type: 'home'
  };

  state = {
    manualEntry: true
  };

  render() {
    const { manualEntry } = this.state;

    return (
      <Fragment>
        {manualEntry && <AutocompleteAddressEntry {...this.props} />}
      </Fragment>
    );
  }
}

export default AutocompleteAddress;
